<main class="mediumContainer">
    <div [class.oneColumn]="lastPosts?.length < 5" class="dashboardContent">
        <app-user-info [hideBadges]="true" [largeAvatar]="true" [user]="currentUser"
                       class="userSection d-flex"></app-user-info>
        <div class="subgroupsSection flex-col gap-10">
            <mat-card class="flex-1" style="overflow: hidden">
                <mat-card-header
                        [ngClass]="community?.subgroup_header_bg_hex == '#ffffff'? 'blackBorder headerRadius': 'accentHeader'"
                        [style.background-color]="community?.subgroup_header_bg_hex"
                        [style.border-bottom]="community?.subgroup_tile_border_color_hex? '4px solid' + community?.subgroup_tile_border_color_hex: null">
                    <div mat-card-avatar>
                        <mat-icon
                                [style.color]="community?.subgroup_tile_text_color_hex || themeService.getReadableColor(community?.subgroup_header_bg_hex)">
                            supervised_user_circle
                        </mat-icon>
                    </div>
                    <mat-card-title
                            [style.color]="community?.subgroup_tile_text_color_hex || this.themeService.getReadableColor(community?.subgroup_header_bg_hex)"
                            class="pb-10">
                        <div [innerHTML]="community?.subgroup_tile_name_rendered || 'Your subgroups'"
                             class="noMargin"></div>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    @if (!subgroups || subgroups.length <= 0 && community?.no_subgroups_text) {
                        <div class="ck-editorControl">
                            <p [innerHTML]="community?.no_subgroups_text"></p>
                        </div>
                    }
                    @if (!subgroups || subgroups.length <= 0 && !community?.no_subgroups_text) {
                        <p> You aren't a member of any subgroups yet</p>
                    }
                    @if (subgroups && subgroups.length > 0) {
                        <mat-list class="subgroupContent">
                            @for (subgroup of subgroups; track subgroup) {
                                <mat-list-item [queryParams]="{ subgroup: subgroup.id }"
                                               [routerLink]="['/feed']" class="clickable listLink p-0">
                                    <div class="flex-col subGroupBorder">
                                        <div [style.background-color]="subgroup.header_bg_color_hex" class="px-10 py-5">
                                            <b [style.color]="subgroup.item_title_bg_color_hex" class="breakSpaces"
                                               [style.font-family]="subgroup.item_header_text_font?.name">{{ subgroup.name }}</b>
                                        </div>
                                        <div [style.background-color]="subgroup.item_body_bg_color_hex" class="px-10">
                                            <p [style.color]="getContrastColor(subgroup.item_body_bg_color_hex)"
                                               [style.font-family]="subgroup.item_body_text_font_type?.name"
                                               class="mt-0 breakSpaces">{{ subgroup.description }}</p>
                                        </div>
                                    </div>
                                </mat-list-item>
                            }
                        </mat-list>
                    }
                </mat-card-content>
            </mat-card>
        </div>
        <mat-card class="mb-10 usefulInfo h-100" style="overflow: hidden;">
            <mat-card-header
                    [ngClass]="community?.useful_info_header_bg_color_hex == '#ffffff'? 'blackBorder headerRadius': 'accentHeader'"
                    [style.background-color]="community?.useful_info_header_bg_color_hex"
                    [style.border-bottom]="community?.useful_information_border_color_hex? '4px solid' + community?.useful_information_border_color_hex: null">
                <div mat-card-avatar>
                    <mat-icon
                            [style.color]="community?.latest_activities_tile_color_hex || this.themeService.getReadableColor(community?.useful_info_header_bg_color_hex)">
                        help
                    </mat-icon>
                </div>
                <mat-card-title
                        [style.color]="community?.useful_information_tile_color_hex ||this.themeService.getReadableColor(community?.useful_info_header_bg_color_hex)"
                        class="pb-10">
                    <div [innerHTML]="community?.useful_info_tile_name? community?.useful_info_tile_name: community?.useful_info_tile_name_rendered || 'Useful information' "
                         class="noMargin"></div>

                </mat-card-title>
            </mat-card-header>
            <mat-card-content class="h-100">
                <mat-list class="threeList">
                    @for (item of menuItems.slice(0, community?.useful_info_button_count || 6); track item) {
                        <mat-list-item
                                class="clickable"
                                [routerLink]="item.routerLink"
                                (click)="item.clickAction && item.clickAction()">
                            <div [class.blackBorder]="item.borderIfWhite"
                                 [style.background-color]="item.backgroundColor"
                                 [style.color]="item.textColor"
                                 class="usefulLink ck-editorControl"
                                 matListItemTitle [innerHTML]="item.title">
                            </div>
                        </mat-list-item>
                    }
                </mat-list>
            </mat-card-content>
        </mat-card>
        <mat-card class="latestActivities" style="overflow: hidden;">
            <mat-card-header
                    [ngClass]="community?.latest_activities_header_bg_color_hex == '#ffffff'? 'blackBorder headerRadius': 'accentHeader'"
                    [style.background-color]="community?.latest_activities_header_bg_color_hex"
                    [style.border-bottom]="community?.latest_activities_border_color_hex? '4px solid' + community?.latest_activities_border_color_hex: null">
                <div mat-card-avatar>
                    <mat-icon
                            [style.color]="community?.latest_activities_tile_color_hex || themeService.getReadableColor(community?.latest_activities_header_bg_color_hex)">
                        stars
                    </mat-icon>
                </div>
                <mat-card-title
                        [style.color]="community?.latest_activities_tile_color_hex || themeService.getReadableColor(community?.latest_activities_header_bg_color_hex)"
                        class="pb-10">
                    <div [innerHTML]="community?.latest_activities_tile_name_rendered || 'Latest activities' "
                         class="noMargin"></div>

                </mat-card-title>
            </mat-card-header>
            <mat-card-content class="h-100">
                @if (lastPosts?.length) {
                    <div class="embla">
                        <div [class.h-100]="lastPosts?.length < 2" class="emblaViewport" emblaCarousel>
                            <div class="mt-10 emblaContainer">
                                @for (post of lastPosts; track post) {
                                    @if (post && !loading) {
                                        <app-post-card
                                                [hideActions]="false"
                                                [hideAttachments]="true"
                                                [hideMedia]="false"
                                                [hidePoll]="true"
                                                [post]="post"
                                                [reducedContent]="false"
                                                [showOpenInFeed]="true"
                                                [showPinnedBadge]="false"
                                                class="emblaSlide"
                                        ></app-post-card>
                                    }
                                }
                            </div>
                        </div>
                        <div [class.d-none]="lastPosts?.length < 2"
                             class="d-flex flex-row flex-space-between emblaArrows align-items-center">
                            @if (this.emblaApi) {
                                <button (click)="this.emblaApi.scrollPrev()"
                                        [disabled]="!emblaApi?.canScrollPrev()"
                                        [matTooltip]="'Previous Post'"
                                        mat-icon-button>
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                </button>
                            }
                            <div #dotsNode id="emblaDots"></div>
                            @if (this.emblaApi) {
                                <button (click)="this.emblaApi.scrollNext()"
                                        [disabled]="!emblaApi?.canScrollNext()"
                                        [matTooltip]="'Next Post'"
                                        mat-icon-button>
                                    <mat-icon>keyboard_arrow_right</mat-icon>
                                </button>
                            }
                        </div>
                    </div>
                }
                @if (!lastPosts?.length) {
                    <div class="w-100 d-flex justify-content-center mt-10">
                        @if (loading == false) {
                            <p>This community has no posts yet</p>
                        }
                        @if (loading) {
                            <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
                        }
                    </div>
                }
            </mat-card-content>
        </mat-card>
        <div class="communityStatistics">
            <mat-card class="mb-10 h-100" style="overflow: hidden;">
                <mat-card-header
                        [ngClass]="community?.community_stats_header_bg_color_hex == '#ffffff'? 'blackBorder headerRadius': 'accentHeader'"
                        [style.background-color]="community?.community_stats_header_bg_color_hex"
                        [style.border-bottom]="community?.community_stats_border_color_hex? '4px solid' + community?.community_stats_border_color_hex: null">
                    <div mat-card-avatar>
                        <mat-icon
                                [style.color]="community?.community_stats_tile_color_hex || themeService.getReadableColor(community?.community_stats_header_bg_color_hex)">
                            timeline
                        </mat-icon>
                    </div>
                    <mat-card-title
                            [style.color]="community?.community_stats_tile_color_hex ||this.themeService.getReadableColor(community?.community_stats_header_bg_color_hex)"
                            class="pb-10">
                        <div [innerHTML]="community?.community_stats_tile_name_rendered || 'Community statistics' "
                             class="noMargin"></div>

                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="flex-row justify-content-center m-10">
                        <mat-button-toggle-group [hideSingleSelectionIndicator]="true"
                                                 (valueChange)="getUserPoints($event)" [value]="pointsDate"
                                                 aria-label="Font Style" class="customToggleGroup">
                            <mat-button-toggle (click)="$event.stopPropagation()"
                                               [style.background-color]="pointsDate == 'allTime'&& community?.all_time_leaderboard_filter_color_hex? community?.all_time_leaderboard_filter_color_hex: null"
                                               [style.color]="this.themeService.getReadableColor(pointsDate == 'allTime'&& community?.all_time_leaderboard_filter_color_hex? community?.all_time_leaderboard_filter_color_hex: null)"
                                               value="allTime">
                                All time
                            </mat-button-toggle>
                            <mat-button-toggle (click)="$event.stopPropagation()"
                                               [style.background-color]="pointsDate == 'lastYear'&& community?.last_year_leaderboard_filter_color_hex? community?.last_year_leaderboard_filter_color_hex: null"
                                               [style.color]="this.themeService.getReadableColor(pointsDate == 'lastYear'&& community?.last_year_leaderboard_filter_color_hex? community?.last_year_leaderboard_filter_color_hex: null)"
                                               value="lastYear">
                                Last year
                            </mat-button-toggle>
                            <mat-button-toggle (click)="$event.stopPropagation()"
                                               [style.background-color]="pointsDate == 'month'&& community?.this_month_leaderboard_filter_color_hex? community?.this_month_leaderboard_filter_color_hex: null"
                                               [style.color]="this.themeService.getReadableColor(pointsDate == 'month' && community?.this_month_leaderboard_filter_color_hex? community?.this_month_leaderboard_filter_color_hex: null)"
                                               value="month">
                                This month
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <div class="statRow">
                        <div class="statCard">
                            @if (pointsDate == 'allTime') {
                                <h5>No. of<br> members</h5>
                            }
                            @if (pointsDate !== 'allTime') {
                                <h5>No. of<br> new members</h5>
                            }
                            <div [style.background-color]="community?.members_number_color_hex"
                                 [style.color]="getContrastColor(community?.members_number_color_hex)"
                                 class="innerStat">
                                @if (!statsLoading) {
                                    <span [countUp]="communityStatistic?.members_count || 0" [duration]="500">
                                        {{ communityStatistic?.members_count || 0 }}
                                    </span>
                                }
                                @if (statsLoading) {
                                    <mat-progress-spinner
                                            [style.stroke]="getContrastColor(community?.members_number_color_hex)"
                                            class="statSpinner"
                                            mode="indeterminate"></mat-progress-spinner>
                                }
                            </div>
                        </div>
                        <div class="statCard">
                            <h5>No. of<br> comments</h5>
                            <div [style.background-color]="community?.comments_number_color_hex"
                                 [style.color]="getContrastColor(community?.comments_number_color_hex)"
                                 class="innerStat">
                                @if (!statsLoading) {
                                    <span [countUp]="communityStatistic?.comments_count || 0 " [duration]="500">
                                        {{ communityStatistic?.comments_count || 0 }}
                                     </span>
                                }
                                @if (statsLoading) {
                                    <mat-progress-spinner
                                            [style.stroke]="getContrastColor(community?.comments_number_color_hex)"
                                            class="statSpinner"
                                            mode="indeterminate"></mat-progress-spinner>
                                }
                            </div>
                        </div>
                        <div class="statCard">
                            <h5>No. of<br>likes/dislikes</h5>
                            <div [style.background-color]="community?.likes_dislikes_number_color_hex"
                                 [style.color]="getContrastColor(community?.likes_dislikes_number_color_hex)"
                                 class="innerStat">
                                @if (!statsLoading) {
                                    <span [countUp]="communityStatistic?.likes_dislikes_count || 0" [duration]="500">
                                        {{ communityStatistic?.likes_dislikes_count || 0 }}
                                    </span>
                                }
                                @if (statsLoading) {
                                    <mat-progress-spinner
                                            [style.stroke]="getContrastColor(community?.likes_dislikes_number_color_hex)"
                                            class="statSpinner"
                                            mode="indeterminate"></mat-progress-spinner>
                                }
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</main>

